<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2023-09-06 17:59:14
 * @LastEditors: 王赵坤
 * @LastEditTime: 2023-12-15 14:30:19
-->
<template>
  <div class="box" style="width: 100vw;display: flex;justify-content: center;">
    <div style="width: 60%;margin-top: 20px;margin-bottom: 10px;">
      <div class="returnn">
        <img src="../../../static/img2/fanhui2.png" alt="">
        <span @click="goBack" style="cursor:pointer;margin-left: 6px;color: #1eb9ee;">返回</span>
      </div>
      <div class="body-top">
        <div class="body-top-top">
          <img style="width: 6px;height: 18px;" src="../../../static/img2/11qian.png" alt="">
          <span style="margin-left: 10px;">{{ $route.query.start_time?'考试详情':'作业详情' }}</span>
        </div>
        <div class="body-top-buttom">
          <div class="top-rigth">
            <div class="top-hed">
              <span>{{infor.title}}</span>
            </div>
            <div class="top-lr">
              <div class="top-lr-tit">
                <span>项目选择：{{infor.cate_name||'无'}}</span>
                <span class="top-lr-tit-span">发布人：{{infor.author}}</span>
                <span class="top-lr-tit-span">考核内容：{{infor.content}}</span>
                <span class="top-lr-tit-span" v-if="$route.query.start_time">开始时间：{{infor.start_time=='null'?'无':infor.start_time}}</span>
                <span class="top-lr-tit-span">截止时间：{{infor.end_time=='null'?'无':infor.end_time}}</span>
                <span class="top-lr-tit-span">描述：{{infor.description}}</span>
              </div>
              <div class="top-lr-tit-rigth" v-if="infor.detail">
                <span>文件：
                  <el-link v-for="(item,index) in JSON.parse(infor.detail)" :key="index" :href="item.url"  type="primary" style="font-size: 18px;">{{ item.name }}</el-link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CourseDetail',
  data() {
    return {
      infor: {},
      myLabel:{background: 'red'},
      detaillist:[]
    }
  },
  created() {},
  methods: {
    getinfor() {
      console.log(this.$route.query.id);
      this.$http.getgetassign({ id: this.$route.query.id }).then((res) => {
        console.log(res)
        this.infor = res.data
        // console.log(res.data.detail);
        // this.detaillist=JSON.parse(res.data.detail)
      })
    },
    goBack(){
      this.$router.go(-1)
    }
  },
  mounted() {
    this.getinfor()
  },
}
</script>


<style lang="less" scoped>
@import '../../../static/fonts/stylemain/style.less';

.box{
  min-height: 77vh;
  background-color: @bg3;
}
.returnn {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
  color: #1eb9ee;
}
// /deep/.el-descriptions .is-bordered .el-descriptions-item__cell{
//   background-color: rgba(25, 26, 31, 0.8);
// }
.body-top {
      width: 1120px;
      height: 680px;
      background-color: @bg2;
      .body-top-buttom {
        width: 1120px;
        padding: 0 50px 0 50px;
        display: flex;
        justify-content: space-between;
        .top-rigth {
          width: 1020px;
          height: 570px;
          background-color: @bg1;
          color: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          .top-hed{
            width: 920px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid @bg3;
            font-size: 18px;
            font-weight: 700;
          }
          .top-lr{
            display: flex;
            // justify-content: space-between;
            width: 920px;
            .top-lr-tit{
              display: flex;
              flex-direction: column;
              height: 500px;
              margin-top: 30px;
              font-size: 18px;
              .top-lr-tit-span{
                margin-top: 40px;
              }
            }
            .top-lr-tit-rigth{
              margin-left: 60px;
              margin-top: 30px;
              font-size: 18px;
              display: flex;
              flex-direction:column;
              .top-lr-tit-span{
                margin-top: 40px;
              }
            }
          }
        }
      }
      .body-top-top {
        width: 1120px;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 24px;
        height: 70px;
        padding: 0 40px 0 40px;
      }
    }
.my-label {
  // background: #E1F3D8;
  background-color: red;
}

.my-content {
  background: #fde2e2;
}
</style>




// WEBPACK FOOTER //
// src/components/User/Homeworkinfordata.vue